import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      width: '100%',
      height: theme.sizingTiny,
      borderRadius: theme.borderRadiusPill,
      backgroundColor: theme.colorFillNeutralFallback,
    },
    variants: {
      size: {
        tiny: {
          height: theme.sizingTiny,
        },
        mini: {
          height: 12,
        },
        micro: {
          height: 8,
        },
        nano: {
          height: 4,
        },
      },
      bgTransparent: {
        true: {
          backgroundColor: 'transparent',
        },
      },
    },
  }
})

export const Progress = styled(View, theme => {
  return {
    base: {
      height: theme.sizingTiny,
      borderRadius: theme.borderRadiusPill,
      backgroundColor: theme.colorActionTextOnbrandDefault,
    },
    variants: {
      size: {
        tiny: {
          height: theme.sizingTiny,
        },
        mini: {
          height: 12,
        },
        micro: {
          height: 8,
        },
        nano: {
          height: 4,
        },
      },
      variant: {
        brand: {
          backgroundColor: theme.colorActionTextOnbrandDefault,
        },
        neutral: {
          backgroundColor: theme.colorTextNeutralDefault,
        },
        'neutral-read-only': {
          backgroundColor: theme.colorTextNeutralReadonly,
        },
        inverse: {
          backgroundColor: theme.colorTextNeutralInverse,
        },
        informative: {
          backgroundColor: theme.colorTextInformativeAlternative,
        },
        success: {
          backgroundColor: theme.colorTextSuccessAlternative,
        },
        warning: {
          backgroundColor: theme.colorTextWarningAlternative,
        },
        danger: {
          backgroundColor: theme.colorTextDangerAlternative,
        },
      },
    },
  }
})
